import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'rcp-labeled-container',
  template: `
    <div class="rcp-labeled-container">
      @if (label) {
        <div class="label-container-label">
          @if (icon) {
            <fa-icon [icon]="icon"></fa-icon>
          }
          <span>
            {{ label }}
          </span>
        </div>
      }

      <div class="label-container-items">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./labeled-container.component.scss'],
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LabeledContainerComponent {
  @Input() icon: IconProp;
  @Input() label: string;
}
